import React from 'react';

import CommonModal from './common/Modal';
import { isForemanRoleId } from '../../utilities/roleUtility';

export const ConfirmExistedEmailDialog = ({
  visible,
  onCancel,
  onConfirmNotIntegrate,
  onConfirmIntegrate,
  isSubmitting = false,
  userRoleCode,
  isCreateNew = false,
}) => {
  const isForeman = userRoleCode && isForemanRoleId(userRoleCode);
  return (
    <CommonModal visible={visible}>
      <div className='ConfirmExistedEmailDialog dialog-md dialog--modal'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            メールアドレスが重複しています
          </span>
        </div>
        <div className='dialog-md__body text-left'>
          このメールアドレスはすでに別のアカウントで使用されています。
          <br />
          複数のアカウントを同一のID（メールアドレス）で操作したい場合は、アカウントを統合することができます。
          <br />
          <br />
          アカウントを統合しない場合は、
          {isForeman &&
            (isCreateNew
              ? '「統合せずに登録」ボタンを押してユーザーを登録するか、'
              : '「統合せずに更新」ボタンを押してアカウントを更新するか、')}
          「戻る」ボタンを押して別のメールアドレスを設定してください。
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            className='btn btn--sub'
            onClick={onCancel ? onCancel : undefined}
            disabled={isSubmitting ? 'disabled' : ''}
          >
            戻る
          </button>
          {isForeman && (
            <button
              className='btn btn--effective'
              onClick={
                onConfirmNotIntegrate ? onConfirmNotIntegrate : undefined
              }
              disabled={isSubmitting ? 'disabled' : ''}
            >
              {isCreateNew ? '統合せずに登録' : '統合せずに更新'}
            </button>
          )}
          <button
            className='btn'
            onClick={onConfirmIntegrate ? onConfirmIntegrate : undefined}
            disabled={isSubmitting ? 'disabled' : ''}
          >
            アカウント統合に進む
          </button>
        </div>
      </div>
    </CommonModal>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmExistedEmailDialog.jsx